import {AppElement, html} from '../AppElement.js';

export default class RoomType extends AppElement {

    static get properties() {
        return {
            hotel_id: {type: Object}
        };
    }

    constructor(props = {}) {
        super();
        this.hotel_id = infinito.vao.controller.storageHelper.getSelectedHotelId();

    }

    render() {
        // This tab frames the new frontend, and Setup is one of the pages the new frontend embeds:
        // rendering it inside that frame would nest the new frontend inside this app inside the new
        // frontend. Embedded, the tab is hidden and the shell opens room types natively, so render
        // nothing at all — a hidden iframe would still load, and still put a token in a query
        // string. Standalone Setup is untouched.
        if (window.infinito.vao.controller.embedHelper.isEmbed()) {
            return html``;
        }

        const authToken = localStorage.getItem('token');
        const hotel = window.infinito.vao.controller.storageHelper.getSelectedHotel();

        return html`
            <div style="height: 100%; min-height: 60vh;">
                <iframe src="https://web.infinito.solutions/app/setup/room-types?embed=true&authToken=${authToken}&hotelId=${hotel.id}"
                        frameBorder="0" style="width: 100%; height: 100%; min-height: inherit;"></iframe>
            </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.RoomType = RoomType;
customElements.define('vao-room-type', RoomType);
